<template>
  <div class="entered-registrar">
    <entered-common
      :perSignUp="hasPermission('team_sign_up')"
      :perDetail="hasPermission('team_detail')"
      :perKeyActive="hasPermission('team_key_active')"
      :perKeySend="hasPermission('team_key_send')"
      :perDiscSignUp='hasPermission("team_disc_sign_up")'
      isTeam
      ref="entered"
      keyId="enteredteamhd"
      @close="clear"
      @open="enter"
      @teamGroupActive="teamGroupActive"
      @sendTeamMessage="sendTeamMessage"
    ></entered-common>
    <el-dialog :visible.sync="dialogVisibleAdd" width="1520px" @close="clear">
      <template v-sole:title>
        <p class="el-dialog-title-sole" @click='errorClick'>
          <span
            >集体报名{{ row.sign_up_count }}/{{ row.class_size }}（新班：{{ row.name }} / {{ row.class_code }}）</span
          >
          <a target="_blank" href="https://www.wjx.cn/jq/101623124.aspx">集体报名异常情况登记</a>
        </p>
      </template>
      <!-- 在dialog中写入html标签 -->
      <team-sign-up ref="teamSignUp" :row="row" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" @click.native="signUp" :loading="loading">报 名</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="500px" center>
      <div class="team-tips-content" v-if="percentage <= 100">
        <div class="m-b-20">正在批量激活集体报名学员，请耐心等待</div>
        <el-progress
          style="width: 200px"
          :text-inside="true"
          :stroke-width="30"
          :percentage="percentage"
          status="success"
        ></el-progress>
      </div>
      <div class="text-center" v-else>
        批量激活集体报名学员完成<span class="red" v-if="failedNum">，失败{{ failedNum }}条</span>。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Progress } from 'element-ui';

import TeamSignUp from '@/components/TeamSignUp';
import { contact, classApi, logger } from '@/api';
import enterMixin from '@/utils/enterMixin';
import enteredCommon from '@/components/enteredCommon';
import perMixin from '@/utils/perMixin';
import checkConflict from '@/utils/signUpConflict';
import localCache from '@/utils/localCache';

export default {
  name: 'EnteredTeam',
  mixins: [enterMixin, perMixin],
  components: {
    ElDialog: Dialog,
    TeamSignUp,
    enteredCommon,
    ElProgress: Progress
  },
  data() {
    return {
      loading: false,
      curItem: {},
      dialogVisibleAdd: false,
      row: {
        fee_level: {}
      },
      percentage: 0,
      centerDialogVisible: false,
      task_id: localCache.getItem('task_id'),
      timeId: '',
      taskResult: {},
      isCheckStatus: false // 检查的请求是否在执行
    };
  },
  mounted() {
    this.initCheck();
  },
  computed: {
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    },
    class_type() {
      return this.$store.state.schoolYear.classType;
    },
    termList() {
      return this.$store.state.schoolYear.list.term;
    },
    failedNum() {
      if (this.taskResult.task_status === 'done') {
        let num = 0;
        Object.keys(this.taskResult.result).forEach(id => {
          const item = this.taskResult.result[id];
          if (Array.isArray(item)) {
            num += item.length;
          }
        });
        return num;
      }
      return 0;
    }
  },
  methods: {
    errorClick() {
      logger.fetchLoggerPost({
        module: 3,
        event_type: 11,
        cusp: `对新班“${this.row.name}”集体报名异常情况登记`,
        status: 1
      });
    },
    initCheck() {
      if (this.task_id && !this.timeId) {
        this.centerDialogVisible = true;
        this.timeId = setInterval(() => {
          this.checkActivateStatus();
        }, 1000);
      }
    },
    enter(row) {
      if (this.task_id) {
        this.$message.warning('请先等候一键激活完成！');
        this.centerDialogVisible = true;
        return;
      }
      this.row = { ...row, fee_level: row.fee_level || {} };
      if (row.class_phase === 2) {
        // 上课中
        this.$confirm('当前班级已开课，报名后属于插班生，是否继续报名？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.curItem = { ...row };
            this.dialogVisibleAdd = true;
          })
          .catch(() => {});
      } else {
        this.curItem = { ...row };
        this.dialogVisibleAdd = true;
      }
    },
    async signUp() {
      const { contact_ids, classNames } = this.$refs.teamSignUp.getSelectStudents();
      if (contact_ids.length) {
        this.loading = true;
        // 检测冲突
        const isRight = await checkConflict({ class_id: this.curItem.id, contact_ids });
        if (!isRight) {
          this.loading = false;
          return;
        }
        const res = await contact.groupSignUp({
          params: {
            contact_ids,
            class_id: this.curItem.id
          }
        });
        if (res) {
          const params = {
            module: 3,
            event_type: 9,
            cusp: `对新班"${this.curItem.name}"集体报名老班${classNames.join('、')}共${contact_ids.length}名学员`,
            status: 1
          };
          logger.fetchLoggerPost(params);
          this.$message.success(res.msg || '报名成功！');
          this.dialogVisibleAdd = false;
          this.search();
        }
        this.loading = false;
      }
    },
    clear() {
      this.$refs.teamSignUp.resetFields();
    },
    search() {
      this.$refs.entered.search();
    },
    checkActivateStatus() {
      if (this.isCheckStatus) return;
      this.isCheckStatus = true;
      contact
        .checkActivateStatus({ task_id: this.task_id })
        .then(res => {
          this.isCheckStatus = false;
          if (res && res.data) {
            this.taskResult = res.data;
            const { task_status } = res.data;
            if (task_status === 'pending') {
              const num = this.percentag + 10;
              this.percentage = num >= 100 ? 99 : num;
            }
            if (task_status === 'done') {
              this.percentage = 100;
              setTimeout(() => {
                this.percentage = 101;
              }, 1000);
              this.endTask();
            }
          } else {
            // 防止异常导致用户用不了
            this.endTask();
          }
        })
        .catch(() => {
          this.isCheckStatus = false;
          this.endTask();
        });
    },
    endTask() {
      this.destroyTimeId();
      localCache.removeItem('task_id');
      this.task_id = '';
    },
    getActiveData() {
      if (!this.term || !this.year || this.year < 0 || this.term < 0 || !this.class_type || this.class_type < 0) {
        this.$message.warning('请先在页面顶部选择学年学期课程类型！');
        return null;
      }
      const data = this.$refs.entered.searchFormData;
      Object.keys(data).forEach(key => {
        if (data[key] === -1 || data[key] === '') delete data[key];
      });
      return { year: this.year, term: this.term, class_type: this.class_type, ...data };
    },
    teamGroupActive() {
      const data = this.getActiveData();
      if (!data) return;
      if (this.task_id) {
        this.initCheck();
        this.centerDialogVisible = true;
        return;
      }
      this.$confirm('是否开始批量激活集体报名学员？', { type: 'warning', confirmButtonClass: 'el-button--danger' })
        .then(() => {
          this.percentage = 0;
          contact.oneKeyActivate(data).then(res => {
            if (res && res.data) {
              logger.fetchLoggerPost({
                module: 3,
                event_type: 7,
                cusp: `对所属学年“${data.year}”、所属学期“${this.termList.find(item => item.value === data.term).label}”、课程类型“${data.class_type === 1 ? '线上班' : '线下班'}”一键激活集体报名`,
                status: 1
              });
              const { task_id } = res.data;
              this.task_id = task_id;
              localCache.setItem('task_id', task_id);
              this.centerDialogVisible = true;
              this.initCheck();
            }
          });
        })
        .catch(() => {});
    },
    destroyTimeId() {
      clearInterval(this.timeId);
      this.timeId = '';
    },
    sendTeamMessage() {
      const data = this.getActiveData();
      if (!data) return;
      this.$confirm('此操作将给集体报名中未缴费的学员发送短信，是否继续？', {
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      })
        .then(() => {
          this.percentage = 0;
          classApi.sendTeamMessages(data).then(res => {
            if (res) {
              logger.fetchLoggerPost({
                module: 3,
                event_type: 8,
                cusp: `对所属学年“${data.year}”、所属学期“${this.termList.find(item => item.value === data.term).label}”、课程类型“${data.class_type === 1 ? '线上班' : '线下班'}”待缴费短信发送`,
                status: 1
              });
              this.$message({
                type: 'success',
                message: res.msg
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  beforeDestroy() {
    this.destroyTimeId();
  }
};
</script>
<style lang="less">
.team-tips-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.el-dialog-title-sole {
  font-size: 18px;
  margin-top: -20px;
  a {
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 4px;
    display: inline-block;
    color: #ffffff;
    background-color: #409eff;
    border-color: #409eff;
  }
}
</style>
